const selectors = ({ get }) => ({
    getToken: () => {
        return get('token');
    },
    getRole: () => {
        const userData = get('userData');
        return userData.role ? userData.role.roleType : '';
    },
    getPermissions: () => {
        const userData = get('userData');
        return userData.role ? userData.role.permissions : [];
    },
    getCompanyStatus: () => {
        const companies = get('companies');
        const chosenCompanyId = get('chosenCompanyId');

        if (!companies || companies.length === 0 || !chosenCompanyId) {
            return null;
        }

        const selectedCompany = companies.find(c => c.id === chosenCompanyId);
        // If company exists but has no status, treat as 'pending'
        return selectedCompany ? (selectedCompany.companyStatus || 'PENDING') : null;
    },
    getUserWithCompanyStatus: () => {
        const companies = get('companies');
        const chosenCompanyId = get('chosenCompanyId');

        if (!companies || companies.length === 0 || !chosenCompanyId) {
            return null;
        }

        const selectedCompany = companies.find(c => c.id === chosenCompanyId);
        // If company exists but has no status, treat as 'pending'
        return selectedCompany ? (selectedCompany.userWithCompanyStatus || 'PENDING') : null;
    },
    hasCompanies: () => {
        const companies = get('companies');
        return companies && companies.length > 0;
    }
})

export default selectors;
